<template>
    <div class="login">
        <div class="logo">
            <img src="../../assets/imgs/logo_avator.png" />
        </div>

        <div class="oAuth_tabs">
            <ul v-show="isPrivate && !$root.isAppleStore">
                <li
                    :class="{'active': item.type == currentTab.type}"
                    v-for="item in oAuthTabs"
                    :key="item.type"
                    @click="oAuthTabCheck(item)"
                >{{item.text}}</li>
            </ul>
        </div>

        <div class="normal-login-wrapper" v-show="currentTab.type == 'normal-login'">
            <div class="fields">
                <mt-field class="email" placeholder="邮箱" type="email" v-model="email">
                    <img src="../../assets/imgs/email_icon.png" />
                </mt-field>
                <mt-field class="password" placeholder="密码" type="password" v-model="password">
                    <img src="../../assets/imgs/pass_icon.png" />
                </mt-field>

                <transition enter-active-class="animated faster zoomIn">
                    <mt-field
                        v-if="isPrivate"
                        class="private"
                        placeholder="私有服务器地址"
                        type="text"
                        v-model="privateURL"
                    >
                        <img src="../../assets/imgs/private_icon.png" />
                    </mt-field>
                </transition>
            </div>

            <!-- <v-touch @tap="login">
                <mt-button class="login_btn" type="primary">登录</mt-button>
            </v-touch>-->
            <v-touch @tap="login">
                <mt-button class="login_btn" type="primary">登录</mt-button>
            </v-touch>
        </div>

        <div class="oAuth-login-wrapper" v-show="currentTab.type == 'oAuth-login'">
            <div class="fields">
                <mt-field class="oAuth_url" placeholder="输入授权地址" type="text" v-model="privateURL">
                    <img src="../../assets/imgs/private_icon.png" />
                </mt-field>
            </div>

            <v-touch @tap="oAuthJump">
                <mt-button class="login_btn" type="primary">前往授权</mt-button>
            </v-touch>
        </div>

        <div class="user_footer_links" v-show="footerTop">
            <span v-if="!$root.isWebview">
                <a :href="`https://${domain}.com/mobile/#/register`" target="_blank">立即注册</a>
            </span>
            <span v-else>
                <a
                    v-if="$root.system=='android'"
                    :href="`https://${domain}.com/mobile/#/register?from=android-app`"
                    target="_blank"
                >立即注册</a>
                <a v-else @click="openRegister">立即注册</a>
            </span>
            <router-link :to="{ name: 'forget' }">忘记密码？</router-link>
            <router-link
                v-if="!isPrivate"
                :to="{ name: 'login', query: { type: 'private' } }"
                @click.native="move = true"
            >私有登录</router-link>
            <router-link
                v-else
                :to="{ name: 'login' }"
                @click.native="move = false;currentTab = {type: 'normal-login',text:'账户登录'} "
            >普通登录</router-link>
        </div>

        <div class="oAuth-mask" v-show="isPrivate && oAuthJumping">
            <div class="oAuth-content">
                <div
                    src="../../assets/imgs/close-icon.svg"
                    alt
                    class="close-icon"
                    @click="close_oAuth_mask"
                ></div>
                <img src="../../assets/imgs/lanhu-logo.svg" alt class="lanhu-logo" />
                <div class="oAuth">
                    <p class="text">需在网页授权完成后，在App登录</p>
                    <div class="login-btn" @click="oAuthLogin">登录</div>
                    <div v-show="oAuthError" class="oAuth-error">
                        <div class="tips">授权失败</div>
                        <p class="oAuth-again" @click="oAuthJumping=false">重试</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="tips-mask" v-show="showTipsMask">
            <div class="tips-content">
                <div class="tips-wrapper">
                    <div class="title">服务协议和隐私政策</div>
                    <div
                        class="text"
                    >请您务必审慎阅读、充分理解"服务协议"和"隐私政策"各项条款,包括但不限于：为了向您提供内容分享服务，我们需要收集您的账号信息、设备信息。您可以在"设置"中，查看、变更、删除个人信息并管理你的授权。</div>
                    <div class="text">
                        你可阅读
                        <span class="link" @click="goSecretsPage('serverAgreement')">《服务协议》</span>和
                        <span class="link" @click="goSecretsPage('secrets')">《隐私政策》</span>
                        了解详细信息。如您同意，请点击“同意”接受我们的服务。
                    </div>
                </div>
                <div class="btn-wrapper">
                    <div class="left" @click="closeDialog">暂不同意</div>
                    <div class="right" @click="closeDialog">同意</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
export default {
    name: "login",
    data() {
        return {
            showTipsMask: false,
            test_url: "",
            oAuthErrorInfo: "",
            oAuthError: false,
            oAuthJumping: false,
            oAuth_url: "",
            currentTab: {
                text: "账户登录",
                type: "normal-login"
            },
            oAuthTabs: [
                {
                    text: "账户登录",
                    type: "normal-login"
                },
                {
                    text: "授权登录",
                    type: "oAuth-login"
                }
            ],
            email: "",
            password: "",
            privateURL: "",
            footerTop: "",
            move: false
        }
    },
    computed: {
        isPrivate() {
            console.log("[登录类型]：", this.$route.query.type)
            return this.$route.query.type == "private"
        },
        backImg() {
            return require("../../assets/imgs/title_back.png")
        }
    },
    mounted() {
        // 检测是否需要弹出隐私协议
        this.checkSecretsDialog()

        console.log("[私有地址]:", this.privateURL)
        this.fixKeyboardUp()

        document.addEventListener("deviceready", onDeviceReady, false)
        function onDeviceReady() {
            window.open = cordova.InAppBrowser.open
        }
    },
    methods: {
        async oAuthLogin() {
            let url = "/account/user_token"
            let params = {
                token_id: localStorage.oAuthId
                // token_id: "f99af5e4-5a5e-4c6b-9941-4fa285d09fa2"
            }
            try {
                let res = await axios.get(url, { params })
                res = res.data
                if (res.code == "00000") {
                    // res.token
                    if (this.isPrivate) {
                        this.setPrivateURL()
                        MtaH5.clickStat("private_login")
                    } else {
                        this.$root.eventBus.$emit("resetSetting")
                    }

                    this.$root.eventBus.$emit("showLoading")
                    try {
                        let result = await axios.post("/account/token_login", { token: res.token })
                        result = result.data
                        this.$root.eventBus.$emit("hideLoading")

                        if (result.token) {
                            console.log("登录成功")
                            this.oAuthError = false
                            if (result.code == "10001") {
                                this.$root.eventBus.$emit("showTip", "该邮箱未注册", "failed")
                            } else if (result.code == "10002") {
                                this.$root.eventBus.$emit("showTip", "咦，账号和密码好像不匹配哦", "failed")
                            } else {
                                this.cacheInfo(result)
                                window.setAuth()
                                await this.$root.remark.getTeamMemberName()
                                this.$router.push({
                                    name: "team",
                                    query: {
                                        team_id: localStorage.teamId
                                    }
                                })
                            }
                        } else {
                            this.oAuthError = true
                            console.log("登录失败")
                        }
                    } catch (e) {
                        this.$root.eventBus.$emit("hideLoading")
                        this.oAuthError = true
                        console.error("登录http状态码错误")
                        console.error(e)
                    }
                } else {
                    this.oAuthError = true
                    console.log("没有能根据该id获取token")
                }
            } catch (e) {
                this.oAuthError = true
                console.error(e)
            }
        },

        close_oAuth_mask() {
            this.oAuthJumping = false
        },

        check_oAuth_url(url) {
            let arr = [
                `dev.${domain}.com`,
                `next.${domain}.com`,
                `beta.${domain}.com`,
                `alpha.${domain}.com`,
                `${domain}.com`
            ]
            if (url === "") {
                this.$root.eventBus.$emit("showTip", "地址不能为空", "failed")
                return false
            } else if (arr.includes(url)) {
                this.$root.eventBus.$emit("showTip", "服务器地址无效", "failed")
                return false
            } else {
                return true
            }
        },

        oAuthJump() {
            this.setPrivateURL()
            let format_ok = this.check_oAuth_url(this.privateURL)
            if (!format_ok) {
                return
            }

            let oAuthUrl = window.baseURL
            let oAuthId = uuidv4()
            // let oAuthId = "1001a0f9-6fae-4b52-abd4-c257e0b14857"
            let from = "webapp"
            let fromType = "client"

            localStorage.oAuthId = oAuthId
            localStorage.from = from
            localStorage.fromType = fromType
            localStorage.oAuthUrl = oAuthUrl

            let url = `${oAuthUrl}/oAuth/redirect?oAuthId=${oAuthId}&from=${from}&fromType=${fromType}`

            // location.href = url

            if (this.$root.system == "android") {
                window.open(url, "_system")
            } else {
                SafariViewController.show({
                    url: url,
                    hidden: false,
                    animated: true
                })
            }

            this.oAuthJumping = true
            this.oAuthError = false
        },

        oAuthTabCheck(item) {
            this.currentTab = item
        },

        openRegister() {
            if (isWebview && system == "ios") {
                // let ref = cordova.InAppBrowser.open(
                //     `https://${domain}.com/mobile/#/register?from=ios-app`,
                //     "_system",
                //     "location=yes"
                // )
                SafariViewController.show({
                    url: `https://${domain}.com/mobile/#/register?from=ios-app`,
                    hidden: false,
                    animated: true
                })
            }

            MtaH5.clickStat("register_btn")
        },
        fixKeyboardUp() {
            setTimeout(() => {
                let h = document.body.clientHeight
                let footer = document.querySelector(".user_footer_links")
                this.footerTop = footer.style.top = h - 3.61 * parseInt(window.rem) + "px"
            }, 100)
        },

        checkSecretsDialog() {
            // 如果本地没有该字段，或者该字段为'true'，就显示隐私协议提示。
            if (!localStorage.isFirstShowTips || localStorage.isFirstShowTips === undefined) {
                this.showTipsMask = true
            } else {
                this.showTipsMask = false
            }
        },

        goSecretsPage(routeName){
            this.$router.push({name:routeName})
        },

        closeDialog() {
            localStorage.isFirstShowTips = "false"
            this.showTipsMask = false
        },

        async login() {
            if (this.isPrivate) {
                this.setPrivateURL()
                MtaH5.clickStat("private_login")
            } else {
                this.$root.eventBus.$emit("resetSetting")
            }

            let email = this.email.trim()
            let password = this.password
            let tips = ""
            if (this.isPrivate) {
                tips = "服务器地址不正确<br>或未允许蓝湖访问网络"
            } else {
                tips = "请在设置中允许蓝湖访问网络"
            }
            let emailCheck = await this.checkEmail(email, tips)
            let passCheck = this.checkPassword(password)

            if (emailCheck && passCheck) {
                this.$root.eventBus.$emit("showLoading")
                let res = await API.account.login(email, password)
                if (res) {
                    let data = res.data
                    if (data.code == "10001") {
                        this.$root.eventBus.$emit("showTip", "该邮箱未注册", "failed")
                    } else if (data.code == "10002") {
                        this.$root.eventBus.$emit("showTip", "咦，账号和密码好像不匹配哦", "failed")
                    } else {
                        this.cacheInfo(data)
                        window.setAuth()
                        await this.$root.remark.getTeamMemberName()
                        this.$router.push({
                            name: "team",
                            query: {
                                team_id: localStorage.teamId
                            }
                        })
                    }
                }

                this.$root.eventBus.$emit("hideLoading")
            }
        },
        setPrivateURL() {
            if (this.privateURL) {
                let baseUrl = this.testURL(this.privateURL)
                window.baseURL = baseUrl
                window.axios.defaults.baseURL = baseUrl + "/api"
                window.useCustomServer = true
                localStorage.baseURL = baseUrl
            }
        },
        testURL(url) {
            let resUrl = ""

            if (/http:\/\/|https:\/\//.test(url)) {
                if (url.slice(-1) == "/") {
                    resUrl = url.slice(0, -1)
                } else {
                    resUrl = url
                }
            } else {
                if (url.slice(-1) == "/") {
                    resUrl = "http://" + url.slice(0, -1)
                } else {
                    resUrl = "http://" + url
                }
            }

            return resUrl
        },
        async checkEmail(email, tips) {
            let reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
            if (!email) {
                this.$root.eventBus.$emit("showTip", "邮箱不能为空哦", "failed")
                return false
            } else if (!reg.test(email)) {
                this.$root.eventBus.$emit("showTip", "这好像不是一个邮箱", "failed")
                return false
            } else {
                let res = await API.account.checkEmail(email, tips)
                let data = res.data

                if (data.code == "10045" || data.code == "10036") {
                    // 非激活Tower用户 || 蓝湖未激活用户
                    this.$root.eventBus.$emit("showTip", "请点下方【忘记密码】激活账户", "normal")
                    return false
                } else if (data.code == "10046") {
                    //激活的tower用户
                    if (!this.filterTowerEmail(email)) {
                        this.$root.eventBus.$emit("showTip", "如果首次登录，请点下方【忘记密码】激活账户", "normal")
                        return false
                    } else {
                        return true
                    }
                } else {
                    return true
                }
            }
        },
        checkPassword(password) {
            if (!password) {
                this.$root.eventBus.$emit("showTip", "密码不能为空哦", "failed")
                return false
            } else if (password.length < 6) {
                this.$root.eventBus.$emit("showTip", "密码不能少于6位", "failed")
                return false
            } else {
                return true
            }
        },
        filterTowerEmail(email) {
            let arr = []
            if (localStorage.resetEmails && localStorage.resetEmails != "undefined") {
                arr = JSON.parse(localStorage.resetEmails)
            }

            if (arr.includes(email)) {
                return true
            } else {
                arr.push(email)
                localStorage.resetEmails = JSON.stringify(arr)
                return false
            }
        },

        async cacheInfo(data) {
            localStorage.token = data.token
            localStorage.name = data.name
            localStorage.color = data.color
            localStorage.email = data.email
            localStorage.avatar = data.avatar
            localStorage.showGuide = "true"
            localStorage.protoGuide = "true"
            localStorage.teams = JSON.stringify(data.teams)
            localStorage.userId = data.id

            //是否有缓存团队
            if (localStorage.teamCache == "undefined" || !localStorage.teamCache) {
                localStorage.teamId = data.teams[0].id
                localStorage.role = data.teams[0].role["name"]
                localStorage.teamName = data.teams[0].name
                localStorage.cloudType = data.teams[0].cloud_type
                localStorage.teamType = data.teams[0].type
            } else {
                let userId = data.id
                let teamCacheData = JSON.parse(localStorage.teamCache)

                if (teamCacheData[userId] && JSON.stringify(data.teams).indexOf(teamCacheData[userId].teamId) > -1) {
                    localStorage.teamId = teamCacheData[userId].teamId
                    this.getCacheTeamInfo(teamCacheData[userId].teamId, data.teams)
                } else {
                    localStorage.teamId = data.teams[0].id
                    localStorage.role = data.teams[0].role["name"]
                    localStorage.teamName = data.teams[0].name
                    localStorage.cloudType = data.teams[0].cloud_type
                    localStorage.teamType = data.teams[0].type
                }
            }
            // 重新登录后，重置分组api接口
            window.setLanhuAPI()
        },
        getCacheTeamInfo(cacheId, teams) {
            teams.forEach(ele => {
                if (ele.id == cacheId) {
                    localStorage.role = ele.role.name
                    localStorage.teamName = ele.name
                    localStorage.cloudType = ele.cloud_type
                    localStorage.teamType = ele.type
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.login {
    width: 100%;
    text-align: center;
    height: 100%;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    box-sizing: border-box;
    .logo {
        width: 4rem;
        margin: 0 auto;
        padding: 3.88rem 0 0 0;
        padding-top: calc(constant(safe-area-inset-top) + 3.88rem);
        padding-top: calc(env(safe-area-inset-top) + 3.88rem);
        img {
            width: 100%;
        }
    }
    .oAuth_tabs {
        height: 2.5rem;
        ul {
            padding-top: 0.2rem;
            li {
                display: inline-block;
                font-size: 0.7rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #9c9d9e;

                &:hover {
                    cursor: pointer;
                }
                &.active {
                    border-bottom: 1px solid #2878ff;
                    color: #222;
                }
            }
            li:first-child {
                margin-right: 1.15rem;
            }
        }
    }
    .fields {
        margin-left: 0.63rem;
        .email {
            margin-bottom: 0.9rem;
        }
        .private {
            margin-top: 0.9rem;
        }
    }
    .user_footer_links {
        width: 13rem;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        top: 88%;
        a {
            font-size: 0.65rem;
            color: #2878ff;
            font-weight: 400;
            float: left;
            width: 4.3rem;
            text-align: center;
        }
    }
    .oAuth-mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        .oAuth-content {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 14rem;
            min-height: 12.9rem;
            background: #fff;
            border-radius: 0.2rem;
            .close-icon {
                background-image: url("../../assets/imgs/close-icon.svg");
                width: 1.1rem;
                height: 1.1rem;
                position: absolute;
                top: 0.75rem;
                right: 0.75rem;
                &:active {
                    background-image: url("../../assets/imgs/close-icon-hover.svg");
                }
            }
            .lanhu-logo {
                width: 3.875rem;
                height: 3.4rem;
                position: absolute;
                bottom: 0;
                left: 0;
            }
            .oAuth {
                .text {
                    font-size: 0.7rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(74, 74, 74, 1);
                    line-height: 2rem;
                    margin-bottom: 1.4rem;
                }

                .login-btn {
                    margin: 0 auto;
                    width: 11rem;
                    height: 2.2rem;
                    background: rgba(40, 120, 255, 1);
                    border-radius: 0.3rem;
                    font-size: 0.9rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    line-height: 2.2rem;
                    text-align: center;
                    &:active {
                        background: #0492fe;
                    }
                }

                .oAuth-error {
                    .tips {
                        margin: 1.4rem auto 0;
                        width: 4.1rem;
                        padding-left: 0.6rem;
                        background: url("../../assets/imgs/oAuth-error.svg") left center no-repeat;
                        background-size: 1.15rem 1.15rem;
                        font-size: 0.7rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(159, 162, 168, 1);
                    }
                    .oAuth-again {
                        margin-top: 0.7rem;
                        font-size: 0.7rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(40, 120, 255, 1);
                    }
                }
            }
        }
    }

    .tips-mask {
        position: fixed;
        z-index: 112;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.2);
        .tips-content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            // min-height: 340px;
            width: 279px;
            background-color: #fff;
            background-size: cover;
            display: flex;
            justify-content: center;
            border-radius: 4px;
            display: flex;
            flex-direction: column;
            .tips-wrapper {
                padding-top: 16px;
                padding-bottom: 16px;
                padding-left: 14px;
                padding-right: 14px;
                text-align: left;
                flex: 1;
                .title {
                    font-size: 18px;
                    font-weight: 700;
                    text-align: center;
                    margin-bottom: 10px;
                }
                .text {
                    font-size: 14px;
                    .link {
                        color: #436ef3;
                    }
                }
            }
            .btn-wrapper {
                flex: 0 0 50px;
                border-top: 1px solid rgba(0, 0, 0, 0.2);
                display: flex;
                .left,
                .right {
                    flex: 1;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 16px;
                }
                .right {
                    color: #436ef3;
                }
            }
        }
    }
}
</style>
